/**
 * Check if a product is Delivery To Store (DTS) compliant.
 *
 * To be eligible for DTS, a product must:
 * - Not be available in the store.
 * - The store must have DTS enabled.
 *
 * @param {boolean} isSkuAvailableInStore - Show if the sku is available in the store.
 * @param {boolean} isStoreDTSEnabled - Show if the store has DTS enabled.
 * @returns {boolean} - A boolean indicating if the product is eligible for DTS.
 */
const isProductDTSCompliant = (isSkuAvailableInStore: boolean, isStoreDTSEnabled: boolean): boolean => {
    return !isSkuAvailableInStore && isStoreDTSEnabled;
};

export const DeliveryToStoreBusinessRules = {
    isProductDTSCompliant,
};
